import React, { createContext, PropsWithChildren, useContext } from 'react'
import type { Country } from '~/types'
import { getDefaultCountry } from '~/utils'

interface Context {
	country: Country
	setCountry: (country: Context['country']) => void
}

export const CountryContext = createContext<Context>({ country: getDefaultCountry(), setCountry: _ => undefined })

export function useCountry() {
	const context = useContext(CountryContext)
	return context.country
}

export class CountryProvider extends React.Component<PropsWithChildren> {
	state = {
		country: getDefaultCountry(),
		setCountry: (country: Context['country']) => {
			this.setState({ country })
		}
	}

	render(): React.ReactNode {
		return <CountryContext.Provider value={this.state}>{this.props.children}</CountryContext.Provider>
	}
}
